// Detects whether the viewer is being embedded — either via the explicit
// `?embed=1` query string or via being framed (window.top !== window).
// Cross-origin frame access throws SecurityError; that is itself a positive
// signal that we are in an iframe with a different parent origin.
export function isEmbedded(href: string, win: Window = window): boolean {
  try {
    const url = new URL(href);
    if (url.searchParams.get('embed') === '1') return true;
  } catch {
    // Invalid URL — fall through to frame check.
  }
  try {
    return win.top !== null && win.top !== win;
  } catch {
    return true; // SecurityError = cross-origin frame
  }
}
